import { ToastType, ToasterService } from '../services/ToasterService';

import { AdminInsightsGetProjectIdRequest } from '../ServerApi/requests/AdminInsightsGetProjectIdRequest';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { ConfirmActionDialog } from '../services/ConfirmActionDialog';
import { HelpService } from '../../commonInfra/services/HelpService';
import { IAdminInsightsResult } from '../ServerApi/types/IAdminInsightsResult';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { ServerService } from '../services/ServerService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { SiteUrls } from '@tableau/shared-urls';
import { ThumbnailProps } from '../../app/spaces/CardView/Thumbnail';

export interface IAdminSiteStatusScope extends ng.IScope {
  hideStatsForLoadTimes: () => boolean;
  hidePerformanceofViews: () => boolean;
  hidePerformanceofFlowRunsOnSite: () => boolean;
  isOnlineEnvironment: () => boolean;
  bridgeEnabled: () => boolean;
  isAdminDataSourceEnabled: boolean;
  processingState: string;
  thumbnailProps: ThumbnailProps;
  learnMoreHref: string;
  navigateUrl: string;
  projectId: string;
  analysisUrl: (sheetUrlId: string) => string;
  siteName: string;
}

export class AdminSiteStatusCtrl {

  public static $inject = [
    '$scope',
    'ServerService',
    'ConfirmActionDialog',
 ];

  constructor(
    private $scope: IAdminSiteStatusScope,
    server: ServerService,
    confirmActionDialog: ConfirmActionDialog,
  ) {

    let siteUrls = new SiteUrls({
      siteUrlName: $scope.siteName,
      queryString: window.location.search
    });

    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.siteStatus()});

    $scope.hideStatsForLoadTimes  = () => {
      return ServerSettingsUnauthenticated.hideAdminVizStatsForLoadTimes();
    };

    $scope.hidePerformanceofViews  = () => {
      return ServerSettingsUnauthenticated.hideAdminVizPerformanceofViews();
    };

    $scope.isOnlineEnvironment = () => {
      return server.isOnlineEnvironment();
    };

    $scope.hidePerformanceofFlowRunsOnSite  = () => {
      return server.hideAdminVizPerformanceofFlowRunsOnSite();
    };

    $scope.bridgeEnabled = () => ServerSettingsUnauthenticated.isBridgeEnabled();

    $scope.analysisUrl = (sheetUrlId: string) => {
      return siteUrls.siteStatusVizUrl(sheetUrlId);
    };

    $scope.$watch('siteName', (newSiteName: string) => {
      siteUrls = new SiteUrls({
        siteUrlName: newSiteName,
        queryString: window.location.search
      });
    });

    // Start of Admin Insights code..........
    if(server.isAdminDataSourceEnabled()){
      this.$scope.isAdminDataSourceEnabled = true;
      this.$scope.learnMoreHref = HelpService.getServerHelpUrlByCategory('insights');
      server.sendRequest(new AdminInsightsGetProjectIdRequest()).
      then((result: IAdminInsightsResult) => {
        if(this.adminInsightsProjectExists(result)){
          $scope.navigateUrl = siteUrls.projectUrl($scope.projectId);
          $scope.thumbnailProps = {
            navigateUrl: siteUrls.projectUrl($scope.projectId),
            defaultImageUrl: 'img/project-thumb-2.png',
            imageCoverBackground: true,
            name: Messages.adminInsightsProjectName(),
            allowDragAndDrop: false,
          };
        } else {
          $scope.navigateUrl = siteUrls.projectUrl('-1');
        }
      }
    );}
  }

  private adminInsightsProjectExists(result: IAdminInsightsResult): boolean {
    this.$scope.projectId = '' + result.projectId;
    if (result.projectId && result.projectId !== -1) {
      return true;
    }
  }
}
Module.instance().controller('AdminSiteStatusCtrl', AdminSiteStatusCtrl);
